<template>
  <v-app>

    <!-- Sidebar -->
    <sidebar-vue v-if="currentUser" />

    <!--  Header  -->
    <header-vue v-if="currentUser" />

    <Loader v-if="loading" />
    <v-main>

      <!-- <v-container> -->
      <div :class="(isLogin) ? '' : 'ma-4'">
        <router-view v-slot="{ Component }">
          <transition name="slide" mode="out-in">
            <component :is="Component" :key="$route.path" />
          </transition>
        </router-view>

      </div>

      <!-- </v-container> -->
    </v-main>
  </v-app>
</template>
<script>
import Login from "./views/auth/Login.vue";
import HeaderVue from "./layouts/Header.vue";
import SidebarVue from "./layouts/Sidebar.vue";
import Loader from "./components/Loader.vue";

export default {
  name: "App",

  components: {
    Login,
    HeaderVue,
    SidebarVue,
    Loader
  },
  data: () => ({
    isLogin: false
  }),
  watch: {
    '$route'() {
      if (this.$route.path == '/user-login') {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    }
  },
  computed: {

    theme() {
      return this.$store.state.theme;
    },
    loading() {
      return this.$store.state.theme.isLoading;
    },
    currentUser() {

      return this.$store.state.auth.user;
    },

  },
  mounted() {
    // this.$progress.finish(); 
  },
  created() {
    console.log(this.$store.state.auth.status)
    /* this.$progress.start();

    this.$router.beforeEach((to, from, next) => {
      this.$progress.start();
      next();
    });

    this.$router.afterEach((to, from) => {
      this.$progress.finish();
    }); */
  },
  methods: {
  },

};
</script>
<style>
@import './assets/css/style.css';
</style>

